import { EAgentType, INewbuildingRecommendation } from '../../types/microfrontends/newbuildingCallbackWidget';
import { EContactType, IRecommendationContact, IRecommendationNewbuilding } from '../../types/recommendations';

export interface IRecommendationNewbuildingWithContact extends IRecommendationNewbuilding {
  contact: IRecommendationContact;
}

const AGENT_TYPE_MAP = new Map<EContactType, EAgentType>([
  [EContactType.Builder, EAgentType.Builder],
  [EContactType.Seller, EAgentType.Seller],
]);

export const mapRecommendationNewbuildingToCallbackRecommendation = (
  newbuilding: IRecommendationNewbuildingWithContact,
): INewbuildingRecommendation => {
  const recommendation: INewbuildingRecommendation = {
    agentName: newbuilding.builder?.name ?? '',
    agentPhone: newbuilding.contact.phone,
    agentType: AGENT_TYPE_MAP.get(newbuilding.contact.type) || EAgentType.Seller,
    buildingStatusInfo: newbuilding.status,
    formattedPrice: newbuilding.minPrice || '',
    newbuildingId: newbuilding.id,
    newbuildingName: newbuilding.name,
    photoUrl: newbuilding.media[0]?.url || null,
    type: 'newbuilding',
    underground: newbuilding.underground
      ? {
          color: newbuilding.underground.lineColor,
          name: newbuilding.underground.undergroundName,
          time: newbuilding.underground.distance,
          transportType: newbuilding.underground.transportType,
        }
      : null,
    url: newbuilding.url,
  };

  return recommendation;
};
